import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sbpro-mobile-app',
  templateUrl: './sbpro-mobile-app.component.html',
  styleUrls: ['./sbpro-mobile-app.component.scss']
})
export class SbproMobileAppComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
